import Action from "@/action/Action"

/**
 * Base action that is expected to potentially cascade.
 */
class CascadingAction extends Action {

    cascade = true
    providerKey = null

    constructor(id, providerKey) {
        super(id)
        this.providerKey = providerKey
    }

}

export default CascadingAction
